<script lang="ts" setup>
import type { IApiMediaWithCrops } from "~/models/generated/IApiMediaWithCrops";

const props = withDefaults(
  defineProps<{
    title?: string | null;
    description?: string | null;
    src?: string | IApiMediaWithCrops[] | null;
    defaultBg?: string | null;
    noOverlay?: boolean;
    height?: number | string;
    align?: string;
    accent?: number | string;
  }>(),
  {
    title: null,
    description: null,
    src: null,
    defaultBg: null,
    noOverlay: false,
    height: 350,
    align: "center",
    accent: 1,
  },
);

const isUmbracoImage = computed( () => {
  return typeof props.src !== "string";
} );

const url = computed( () => {
  let result = props.src;

  if ( props.src ) {
    if ( typeof props.src !== "string" ) {
      result = props.src?.[0].url;
    }
  } else if ( props.defaultBg ) {
    result = props.defaultBg;
  }

  return result;
} );

const alignClass = computed( () => {
  let result = null;

  if ( props.align === "left" ) {
    result = "banner-image--left";
  } else if ( props.align === "right" ) {
    result = "banner-image--right";
  }

  return result;
} );

const accentClass = computed( () => {
  let result = null;

  if ( props.accent !== null && props.accent !== undefined ) {
    result = `banner-image--accent-${props.accent}`;
  }

  return result;
} );
</script>

<template>
  <div
    class="banner-image"
    :class="[alignClass, accentClass]"
    :style="{ 'min-height': height + 'px' }">
    <div
      class="banner-image__content-wrapper"
      :class="{
        'banner-image__content-wrapper--has-text': title || !!$slots.default,
        'banner-image__content-wrapper--no-overlay': noOverlay,
      }">
      <div class="banner-image__image-wrapper">
        <!--          <nuxt-picture v-if="url" -->
        <!--                        :src="url" -->
        <!--                        :provider="isUmbracoImage ? 'umbraco' : 'ipx'" -->
        <!--                        sizes="sm:400px md:600px lg:1200px" -->
        <!--                        :height="height" -->
        <!--                        quality="75" -->
        <!--                        width="1200" -->
        <!--                        class="banner-image__image" -->
        <!--                        :img-attrs="{ role: 'presentation' }" /> -->
      </div>

      <div class="container">
        <div class="banner-image__content">
          <slot>
            <h1
              v-if="title"
              class="banner-image__heading">
              {{ title }}
            </h1>

            <p
              v-if="description"
              class="banner-image__description">
              {{ description }}
            </p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/_variables.scss';

.banner-image {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  &__content-wrapper {
    display: flex;
    align-items: stretch;
    max-width: var(--container-max-width);
    flex-grow: 1;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    position: relative;

    &--has-text:not( &--no-overlay ) {
      .banner-image__image-wrapper::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-image: linear-gradient( 0deg,
        rgba( 22, 22, 22, 0.8 ) 0%,
        rgba( 22, 22, 22, 0.7 ) 15%,
        rgba( 22, 22, 22, 0.6 ) 33%,
        rgba( 22, 22, 22, 0 ) 100% );
      }
    }
  }

  &__image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var( --muted-bg );
  }

  &__image,
  &__image:deep( img ) {
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    padding-bottom: 0 !important;
    object-fit: cover;
  }

  &__content {
    position: relative;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
  }

  &__heading {
    text-transform: none;
    max-width: 66.66%;
    text-align: center;
    color: #070e35;
    color: #fff;

    @media ( max-width: 991px ) {
      max-width: none;
    }
  }

  &__description {
    color: #070e35;
    color: #fff;
  }

  &--left {
    .banner-image__content {
      align-items: flex-start;
    }
  }

  &--right {
    .banner-image__content {
      align-items: flex-end;
    }
  }
}

.container {
  width: 100%;
}

.container .container {
  padding: 0 5px;
}
</style>
